export const CUSTOM_PRICE_LIST_ACTION = "CUSTOM_PRICE_LIST_ACTION";
export const CUSTOM_PRICE_LIST_SUCCESS = "CUSTOM_PRICE_LIST_SUCCESS";
export const CUSTOM_PRICE_LIST_FAIL = "CUSTOM_PRICE_LIST_FAIL";
export const CUSTOM_PRICE_DETAIL_ACTION = "CUSTOM_PRICE_DETAIL_ACTION";
export const CUSTOM_PRICE_DETAIL_SUCCESS = "CUSTOM_PRICE_DETAIL_SUCCESS";
export const CUSTOM_PRICE_DETAIL_FAIL = "CUSTOM_PRICE_DETAIL_FAIL";
export const CUSTOM_PRICE_DETAIL_UPDATE_ACTION = "CUSTOM_PRICE_DETAIL_UPDATE_ACTION";
export const CUSTOM_PRICE_DETAIL_CREATE_ACTION = "CUSTOM_PRICE_DETAIL_CREATE_ACTION";